<template>
  <div class="page_container">
    <div class="content-box">
        <!-- <FormContainer
            :title="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.HEADING')"
            @onDiscard="onDiscard"
        > -->
            <SpinnerWithMessage
                :isLoading="isFetching"
                :message="$t('CAMPAIGN.NETWORK_ERR.LOADING_RECORD')"
                className="py_20 px_20"
            />
            <div v-if="!isFetching" class="addBoostForm">
                <InputField
                    v-model="form.title"
                    :label="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.TITLE.LABEL')"
                    :placeholder="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.TITLE.PLACEHOLDER')"
                    :error="$v.form.title.$error ? $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.TITLE.ERR') : ''"
                    :infoList="[]"
                    @blur="$v.form.title.$touch"
                />
                <InputField
                    v-model="form.description"
                    :label="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.DESCRIPTION.LABEL')"
                    :placeholder="$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.DESCRIPTION.PLACEHOLDER')"
                    :error="$v.form.description.$error ? $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.DESCRIPTION.ERR') : ''"
                    :infoList="[]"
                    type="textarea"
                    :rows="5"
                    @blur="$v.form.description.$touch"
                />
                <div>
                    <FormBuilder
                        v-for="(field,index) in form.form_data.fields"
                        :key="index"
                        :field="field"
                        :index="index"
                        :isGroupFieldOption="true"
                        :fieldTypeTrackBy="'value'"
                        :fieldTypeLabelBy="'name'"
                        :fieldTypeOptions="boost_type_options"
                        :fieldBodyType="getFieldBodyType(field)"
                        className="mt_24"
                        :bindOptions="llmContactAttributes"
                        :bindTrackBy="'value'"
                        :bindLabelBy="'name'"
                        :disabled="disabledIds.includes(field.id)"
                        :v="$v.form.form_data.fields.$each[index]"
                        @onAddNewField="onAddNewField"
                        @onCopyField="onCopyField"
                        @onDeleteField="onDeleteField"
                        @onToggleRequired="onToggleRequired"
                        @appendNewOption="function(item){onAppendNewOption(index,item)}"
                    />
                </div>
                <div class="my_24">
                    <woot-button
                        class=""
                        :isDisabled="uiFlags.isCreating"
                        :is-loading="uiFlags.isCreating"
                        @click="onSubmit"
                        >
                        {{ $t('CAMPAIGN.CAMPAIGN_FORMS.ADD.ACTIONS.SUBMIT') }}
                    </woot-button>
                </div>
                <!-- <pre>{{llmContactAttributes}}</pre> -->
            </div>
        <!-- </FormContainer> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputField from "components/ui/inputs/InputField.vue";
import FormBuilder from "components/ui/FormBuilder.vue";
import FormContainer from "components/ui/FormContainer.vue";
import InputCard from "components/ui/inputs/InputCard.vue";
import { required, minLength } from 'vuelidate/lib/validators';
import { BOOST_TYPE_OPTIONS, } from './boostFormConstant';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';
// app\javascript\dashboard\api\campaign_forms.js
import CampaignFormsAPI from "dashboard/api/campaign_forms.js";
import SpinnerWithMessage from "shared/components/SpinnerWithMessage.vue";


export default {
    components: {
        InputField,
        FormBuilder,
        FormContainer,
        InputCard,
        SpinnerWithMessage,
    },
    mixins: [alertMixin,helperMixin],
    data(){
        return {
            isFetching:false,

            boost_type_options:BOOST_TYPE_OPTIONS,
            form:{
                title: "",
                description: "",
                form_data: {
                    fields: [],
                },
            },
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'getCurrentUser',
            getAccount: 'accounts/getAccount',
            uiFlags: "campaigns/getUIFlagsForms",
            llmContactAttributes: 'attributes/getLLMcontactAttributes',
        }),
        currentAccount(){
            return this.getAccount(this.currentUser.account_id);
        },
        disabledIds(){
            return ['email','phone_number','fullname']
        },
    },
    validations:{
        form:{
            title:{
                required,
            },
            description:{
                required,
            },
            form_data:{
                fields:{
                    $each:{
                        id: { required },
                        label: { required },
                    }
                }
            },
        },
    },
    mounted(){
        // this.populateForm(this.getDefaultForm());
        // if not allowed for form frature, redirect to home
    },
    watch: {
        currentAccount: {
            handler(newVal) {
                if (newVal?.features && !newVal.features.forms) {
                    // redirect to home if not allowd form feature
                    this.$router.push("/");
                }
            },
            immediate: true
        }
    },
    async activated(){

        console.log("Activated form page",this.$route.params);
            this.isFetching = true;
            await this.$store.dispatch('attributes/fetchLlmContactAttributes');
        if (this.$route.params?.campaign_form_id) {
            // populate form by id
            const data = await this.getExistFormById(this.$route.params.campaign_form_id);
            if(data.id){
                this.populateForm(data);
            }else{
                // navigate back to list
                this.$router.push({name:"campaign_form_list"});
            }
        }else{
            this.populateForm(this.getDefaultForm());
        }
        this.isFetching = false;
    },
    methods:{
        async onSubmit(){
            try {
                // field validator
                this.$v.$touch();
                if (this.$v.$invalid){
                    console.log("erreor",this.$v);
                    return
                };

                const payload = {
                    ...this.form,
                    form_data: {
                        ...this.form.form_data,
                        fields: this.form.form_data.fields.map((item,index) => {
                            return {
                                ...item,
                                position: index,
                                type: item.type.value,
                                bind_to: item.bind_to?.value || null,
                            }
                        }),
                    }
                }
                // dispatch
                if(this.$route.params?.campaign_form_id){
                    await this.$store.dispatch('campaigns/updateCampaignForm', {campaignFormId:this.$route.params.campaign_form_id,payload});
                    this.showAlert(this.$t('CAMPAIGN.CAMPAIGN_FORMS.EDIT.ACTIONS.SUCCESS'));
                }else{
                    await this.$store.dispatch('campaigns/createCampaignForm', payload);
                this.showAlert(this.$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.ACTIONS.SUCCESS'));
                }
                // reset form
                this.populateForm(this.getDefaultForm());
                this.$v.$reset();
                await this.$nextTick();
                this.$router.push({name:"campaign_form_list"})
            } catch (error) {
                console.log(error);
                this.showErrAlert(error,this.$t('CAMPAIGN.CAMPAIGN_FORMS.ADD.ACTIONS.FAIL'));
            }
        },
        populateForm(dbForm={}){

            const tempForm = {
                ...this.getDefaultForm(),
                ...dbForm,
            }
            tempForm.form_data.fields = dbForm.form_data.fields.map(item => {
                return {
                    ...item,
                    type: this.boost_type_options.find(option => option.value === item.type),
                    bind_to: this.llmContactAttributes.find(option => option.value === item.bind_to),
                }
            });
            // if no items add a default one
            if (!tempForm.form_data.fields.length) {
                // push 3 item
                this.disabledIds.forEach((id,index) => {
                    tempForm.form_data.fields.push({
                        id,
                        type: BOOST_TYPE_OPTIONS[0],
                        label: id,
                        required: false,
                        position: index + 1,
                        bind_to: null,
                        options:[],
                        description:"",
                    });
                });
                // tempForm.form_data.fields.push({
                //     id: this.generateRandomString(),
                //     type: BOOST_TYPE_OPTIONS[0],
                //     label: "",
                //     required: false,
                //     position: tempForm.form_data.fields.length + 1,
                //     bind_to: null,
                //     options:[],
                // })
            }
            console.log(tempForm,dbForm);
            this.form = tempForm;
        },
        async getExistFormById(id){
            try {
                this.isFetching = true;
                const {data} = await  CampaignFormsAPI.fetchCampaignFormById(id);
                console.log(data);
                return data;
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }finally{
                this.isFetching = false;
            }
        },
        onAddNewField(index){
            const id = this.generateUniqueId();
            this.form.form_data.fields.splice(index + 1, 0, {
                id,
                type: this.boost_type_options[0],
                label: "",
                required: false,
                position: index + 1,
                bind_to: null,
                options:[],
                description:"",
            });
        },
        getDefaultForm(){
            return {
                title: "",
                description: "",
                form_data: {
                    fields: [],
                },
            }
        },
        generateUniqueId(){
            let id;
            do {
                id = this.generateRandomString();
            } while (this.form.form_data.fields.some(field => field.id === id));
            return id;
        },
        onCopyField({index,field}){
            // Create a deep copy of the item (avoid mutating original)
            const newItem = JSON.parse(JSON.stringify(field));
            const id = this.generateUniqueId();
            newItem.id = id;
            newItem.position = this.form.form_data.fields.length + 1;
            this.form.form_data.fields.splice(index + 1, 0, newItem);
        },
        onDeleteField({index}){
            this.form.form_data.fields.splice(index, 1);
        },
        onToggleRequired({index}){
            this.form.form_data.fields[index].required = !this.form.form_data.fields[index].required;
        },
        onDiscard(){
            console.log("DIscard");
        },
        getFieldBodyType(field){
            return field.type && field.type.value;
        },
        onAppendNewOption(index,item){
            this.form.form_data.fields[index].options.push('');
        },
    },
}
</script>

<style lang="scss" scoped>
.addBoostForm{
    max-width: 80rem;
    margin: auto;
}
</style>